import React from "react";
import styles from "./TariffItem.module.scss";

interface TariffItemProps {
    title?: string,
    text?: string,
    value?: string,
}

const TariffItem: React.FC<TariffItemProps> = (
    {
        title,
        text,
        value
    }) => {
    return (
        <div className={styles.tariffItem}>
            {title && <div className={styles.tariffItemTitle}>{title}</div>}
            {text && <div className={styles.tariffItemText}>{text}</div>}
            {value && <div className={styles.tariffItemValue}>{value}</div>}
        </div>
    )
}
export default TariffItem;